import { BaseFactory } from '../base.factory';
import { Group, UserModel } from '../../model/user-model';

export class UsersFactory extends BaseFactory {

    constructor() {
        // super( true, true, process.env.SUITE_URL);
        super(true, true, `${process.env.VUE_APP_SUITE_URL}`);
    }

    public createUser = async (user: UserModel): Promise<UserModel> => {
        try {
            const result = await this.post(`/user`, user) as UserModel;
            return result;
        } catch (error) {
            throw error;
        }
    }

    public updateUser = async (user: UserModel): Promise<UserModel> => {
        try {
            const result = await this.put(`/user`, user) as UserModel;
            return result;
        } catch (error) {
            throw error;
        }
    }

    public changePassword = async (userId: string, newPassword: string, isTemporary = false): Promise<UserModel> => {
        try {
            const user = {id: userId, credentials: [{temporary: isTemporary, value: newPassword }]} as UserModel;
            const result = await this.put(`/user`, user, undefined) as UserModel;
            return result;
        } catch (error) {
            throw error;
        }
    }

    public getUsers = async (first = 0, max = 100): Promise<UserModel[]> => {
        try {
            const result = await this.get(`/user?first=${first}&max=${max}`, undefined) as UserModel[];
            return result;
        } catch (error) {
            throw error;
        }
    }

    public getUserById = async (id: string): Promise<UserModel> => {
        try {
            const result = await this.get(`/user/${id}`, undefined) as UserModel;
            return result;
        } catch (error) {
            throw error;
        }
    }

    public getGroupByUserLogged = async(): Promise<Group> =>  {
        try {
            const result = await this.get(`/user/group`, undefined) as Group;
            return result;
        } catch (error) {
            throw error;
        }
    }

    public countUsers = async (): Promise<number> => {
        try {
            const result = await this.get(`/user/count`, undefined) as number;
            return result;
        } catch (error) {
            throw error;
        }
    }

    public enableUser = async (id: string): Promise<void> => {
        try {
            await this.patch(`/user/enable/${id}`, undefined);
        } catch (error) {
            throw error;
        }
    }

    public disableUser = async (id: string): Promise<void> => {
        try {
            await this.patch(`/user/disable/${id}`, undefined);
        } catch (error) {
            throw error;
        }
    }
}

